import { Box, styled } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  "& .rct-node.GROUP .rct-title": {
    fontWeight: 500,
    color: theme.palette.secondary.main,
  },
  "& .rct-node.LAYER .rct-title": {
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  "& label": {
    display: "inline-flex",
    alignItems: "center",
  },
}));

export const Row = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 34px;
`;
